import { NavigationDto } from '@asset-metrix/portal-gateway-client-js';

import { getDetailsFromSearchParams } from '../../utils/getDetailsFromSearchParams';

function pageSlugStartsWithItemSlug(pageSlug: string) {
  return (item: { completeSlug: string }) =>
    pageSlug.startsWith(`${item.completeSlug}/`) ||
    pageSlug === item.completeSlug;
}

export function getActiveItemIndex(
  navigationItems: { completeSlug: string }[],
  pageSlug: string
): number | undefined {
  const index = navigationItems.findIndex(pageSlugStartsWithItemSlug(pageSlug));
  return index === -1 ? undefined : index;
}

export function getActiveItem(
  navigationItems: NavigationDto['rootNavigationItems'],
  pageSlug: string
): NavigationDto['rootNavigationItems'][number] | undefined {
  return navigationItems.find(pageSlugStartsWithItemSlug(pageSlug));
}

export function getActiveDynamicItemIndex(
  navigationItems: { completeSlug: string }[],
  locationPathname: string,
  locationSearch: string
): number | undefined {
  const searchParams = new URLSearchParams(locationSearch);
  const { detailsDiscriminator, detailsValue } =
    getDetailsFromSearchParams(searchParams);

  if (detailsDiscriminator == null || detailsValue == null) {
    return undefined;
  }

  const index = navigationItems.findIndex((dni) => {
    const dniUrl = new URL(dni.completeSlug, globalThis.location.origin);
    const dynamicItemSearchParams = new URLSearchParams(dniUrl.search);
    const {
      detailsDiscriminator: dynamicItemDetailsDiscriminator,
      detailsValue: dynamicDetailsValue,
    } = getDetailsFromSearchParams(dynamicItemSearchParams);
    if (
      dynamicItemDetailsDiscriminator == null ||
      dynamicItemDetailsDiscriminator !== detailsDiscriminator ||
      dynamicDetailsValue == null ||
      dynamicDetailsValue !== detailsValue
    ) {
      return false;
    }

    return locationPathname.startsWith(dniUrl.pathname);
  });
  return index === -1 ? undefined : index;
}
